<template>
  <div class="dropdown">
    <button
      class="btn btn-primary dropdown-toggle additional-options-button text-white shadow"
      type="button"
      id="additionalOptionsButton"
      @mousedown="toggleAdditionalOptions"
      aria-haspopup="true"
      :aria-expanded="displayOptionsDropdown"
      aria-controls="toolbar-additional-options-container"
    >
      {{ widerThan360 ? "Additional Options" : "Options" }}
    </button>
    <ul
      class="dropdown-menu additional-options-container"
      :class="{
        'd-none': !displayOptionsDropdown,
        'd-block show': displayOptionsDropdown,
        'mobile-align-right': isMobile == 'mobile',
      }"
      id="toolbar-additional-options-container"
      aria-labelledby="additionalOptionsButton"
    >
      <li>
        <a
          v-on:click="print()"
          class="dropdown-item dropdown-link"
          href="#"
          title="Print"
        >
          <PrintSVG />
          Print Property Report
        </a>
      </li>
      <li>
        <a
          v-if="!isFuture"
          class="dropdown-item dropdown-link"
          :href="taxBillUrl || '#'"
          target="_blank"
          title="Tax Bill"
        >
          <DollarBillSVG />
          View Tax Bill</a
        >
      </li>
      <li>
        <a
          v-if="
            (item.propertyInfo.TaxType === 'Real' ||
              item.propertyInfo.TaxType === 'R') &&
              parcelPrcUrl &&
              !isFuture
          "
          class="dropdown-item dropdown-link"
          :href="parcelPrcUrl"
          rel="noopener"
          target="_blank"
          title="Property Record Card"
        >
          <PDFFileSVG />
          Property Record Card</a
        >
      </li>
      <li>
        <a
          v-if="
            (item.propertyInfo.TaxType === 'Real' ||
              item.propertyInfo.TaxType === 'R') &&
              parcelForm11Url &&
              !isFuture
          "
          class="dropdown-item dropdown-link"
          :href="parcelForm11Url"
          rel="noopener"
          target="_blank"
          title="Form 11"
        >
          <PDFFileSVG />
          Form 11</a
        >
      </li>
      <li>
        <a
          v-if="
            (item.propertyInfo.TaxType === 'Real' ||
              item.propertyInfo.TaxType === 'R') &&
              externalGisParcelUrl &&
              !isFuture
          "
          class="dropdown-item dropdown-link"
          :href="externalGisParcelUrl"
          rel="noopener"
          target="_blank"
          title="Click To View Parcel GIS Map"
        >
          <MapSVG />
          View GIS Map
        </a>
      </li>
      <li>
        <a
          v-if="
            (item.propertyInfo.TaxType === 'Real' ||
              item.propertyInfo.TaxType === 'R') &&
              externalGisCountyUrl &&
              !externalGisParcelUrl &&
              !isFuture
          "
          class="dropdown-item dropdown-link"
          :href="externalGisCountyUrl"
          rel="noopener"
          target="_blank"
          title="Click To View County GIS Map"
        >
          <MapSVG />
          View GIS Map
        </a>
      </li>
      <li class="dropdown-item dropdown-link" @click="copyUrlToClipboard">
        <CopyLinkSVG />
        Copy link
      </li>
    </ul>
  </div>
</template>
<style scoped>
ul#toolbar-additional-options-container {
  width: max-content !important;
}
.additional-options-button:hover {
  background-color: rgb(0, 85, 86, 0.8);
}
.additional-options-container {
  background-color: rgb(185, 217, 216);
  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.2);
}
.dropdown-link {
  color: rgb(33, 37, 41);
  padding: 0.5rem;
  font-weight: 500;
}
.dropdown-link:hover {
  color: white;
  background-color: rgb(52, 148, 148);
}
.mobile-align-right {
  right: 0;
}
</style>
<script>
import PDFFileSVG from "../svg/PDFFileSVG.vue";
import MapSVG from "../svg/MapSVG.vue";
import PrintSVG from "../svg/PrintSVG.vue";
import DollarBillSVG from "../svg/DollarBillSVG.vue";
import CopyLinkSVG from "../svg/CopyLinkSVG.vue";

export default {
  components: {
    CopyLinkSVG,
    PrintSVG,
    MapSVG,
    PDFFileSVG,
    DollarBillSVG,
  },
  data() {
    return {
      displayOptionsDropdown: false,
    };
  },
  computed: {
    taxBillUrl: function() {
      if (
        !this.county.corpCode ||
        !this.item.propertyInfo.BillingDuplicateNumber
      ) {
        return;
      }
      return (
        process.env.VUE_APP_TAXBILLSERVICE +
        "?county=" +
        this.county.corpCode +
        "&dup=" +
        this.item.propertyInfo.BillingDuplicateNumber
      );
    },
    parcelPrcUrl: function() {
      if (!this.county.prcUrl) {
        return;
      }
      let url = this.county.prcUrl;
      url = url.replace("{{StateKey}}", this.item.propertyInfo.StateKey);
      url = url.replace(
        "{{UnformattedStateKey}}",
        this.item.propertyInfo.UNFORMATEDSTATEKEY
      );
      url = url.replace("{{PayYear}}", this.item.propertyInfo.PayYear);
      return url;
    },
    parcelForm11Url: function() {
      if (!this.county.form11Url) {
        return;
      }
      let url = this.county.form11Url;
      url = url.replace("{{StateKey}}", this.item.propertyInfo.StateKey);
      url = url.replace(
        "{{UnformattedStateKey}}",
        this.item.propertyInfo.UNFORMATEDSTATEKEY
      );
      return url;
    },
    externalGisParcelUrl: function() {
      if (!this.county.externalGisParcelUrl) {
        return;
      }
      let url = this.county.externalGisParcelUrl;
      url = url.replace("{{StateKey}}", this.item.propertyInfo.StateKey);
      url = url.replace(
        "{{UnformattedStateKey}}",
        this.item.propertyInfo.UNFORMATEDSTATEKEY
      );
      return url;
    },
    externalGisCountyUrl: function() {
      return this.county.externalGisUrl;
    },
  },
  methods: {
    blurHandler(event) {
      if (
        !event.target.matches("#toolbar-additional-options-container") &&
        !event.target.matches("#additionalOptionsButton") &&
        this.displayOptionsDropdown === true
      ) {
        this.displayOptionsDropdown = false;
      }
    },
    print: function() {
      // document.getElementById("billing-detail")
      // previously tracked in Google Analytics' Universal Analytics (GA3)
      // tracking internal click events with GA4 requires Google Tag Manager
      window.print();
    },
    toggleAdditionalOptions() {
      this.displayOptionsDropdown = !this.displayOptionsDropdown;
    },
  },
  mounted() {
    window.addEventListener("click", this.blurHandler);
  },
  props: {
    copyUrlToClipboard: {
      type: Function,
      required: true,
    },
    county: {
      type: Object,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    isFuture: {
      type: Boolean,
      required: false,
      default: false,
    },
    widerThan360: {
      type: Boolean,
      required: false,
      default: false,
    },
    isMobile: {
      type: String, //'mobile' | 'desktop'
      required: true,
    },
  },
};
</script>
